import React, { useState, useContext, useEffect } from 'react';
import { AppContext } from '../contexts/app.context';
import OtherGroupsRegistrationForm from './otherGroupsRegistrationForm';
import SchoolRegistrationForm from './schoolRegistrationForm';
import { Loader } from '../components';
import { getDashboardDetails } from '../service';

const Dashboard = () => {
  const { profile, setProfile } = useContext(AppContext);
  const [storedData, setStoredData] = useState(null);
  const [refreshing, setRefreshing] = useState(false);

  const refresh = async () => {
    try {
      setRefreshing(true);
      const { data } = await getDashboardDetails();
      setProfile({ ...data, loggedIn: true, updatedAt: new Date() });
    } catch (error) {
      console.log(error);
    } finally {
      setRefreshing(false);
    }
  };

  useEffect(() => {
    const { establishmentDetails, inchargePersons, emailConsent, classes } = profile;

    if (!establishmentDetails?.registrationType) return;

    setStoredData({
      establishmentDetails: {
        ...establishmentDetails,
        privateContract: establishmentDetails.privateContract ? 'true' : 'false',
        representative: establishmentDetails.representative ? 'true' : 'false',
      },
      inchargePersonDetails: inchargePersons.find((person) => !person.secondIncharge),
      inchargePersonAnother: inchargePersons.find((person) => person.secondIncharge)
        ? 'false'
        : 'true',
      inchargePersonAnotherDetails: inchargePersons.find((person) => person.secondIncharge),
      classes: classes.map((classDetails) => ({
        ...classDetails,
        experienceDetails: {
          tourType: classDetails?.timeSlot?.tourType,
          timeSlot: classDetails?.timeSlot?.timeSlot,
          level: classDetails?.level,
          professionId: classDetails?.timeSlot?.professionId,
          guidedTourType: classDetails?.timeSlot?.guidedTourType,
        },
        bookExperience: classDetails.bookExperience ? 'true' : 'false',
        handicap: classDetails.handicap ? 'true' : 'false',
        picnicOnSite: classDetails.picnicOnSite ? 'true' : 'false',
      })),
      emailConsent: {
        ...emailConsent,
        emailConsent: emailConsent.emailConsent ? 'true' : 'false',
        email:
          emailConsent.email || inchargePersons.find((person) => !person.secondIncharge)?.email,
      },
    });
  }, [profile]);

  if (!storedData) return <Loader loaderType={'sync'} bgColor={'transparent'} />;

  if (storedData?.establishmentDetails?.registrationType === 'other-group')
    return (
      <OtherGroupsRegistrationForm
        storedData={storedData}
        refresh={refresh}
        refreshing={refreshing}
      />
    );
  return (
    <SchoolRegistrationForm storedData={storedData} refresh={refresh} refreshing={refreshing} />
  );
};

export default Dashboard;
